import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=8f637dde&lang=html"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=8f637dde&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/var/www/malayan/web/components/global/Breadcrumbs.vue').default,Carousel: require('/var/www/malayan/web/components/global/Carousel.vue').default,ProductCards: require('/var/www/malayan/web/components/global/ProductCards.vue').default})
